<h2 class="info-title" [class]="{ 'info-title--small': small() }">
  {{ infoTitle() }}

  <sup class="info-title__total-items">{{ totalItems() }}</sup>
</h2>
